import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { TrashIcon, ShoppingBagIcon, RotateCcwIcon } from 'lucide-react';
export function SolutionSection() {
  return <section className="w-full px-6 py-10 md:py-14" data-id="element-329">
      <div className="max-w-2xl mx-auto" data-id="element-330">
        <AnimatedSection data-id="element-331">
          <div className="w-12 h-px bg-sand mx-auto mb-8" data-id="element-332" />
        </AnimatedSection>

        <AnimatedSection data-id="element-333">
          <h2 className="font-serif text-3xl md:text-4xl text-charcoal leading-tight mb-3" data-id="element-334">
            La solución no es hacerlo perfecto.
          </h2>
          <p className="font-serif text-2xl md:text-3xl text-teal leading-snug mb-6" data-id="element-335">
            Es hacerlo en el orden correcto.
          </p>
        </AnimatedSection>

        <AnimatedSection delay={0.1} data-id="element-336">
          <div className="space-y-3 text-charcoal/80 text-base md:text-lg leading-relaxed mb-6" data-id="element-337">
            <p data-id="element-338">
              Por eso creé{' '}
              <strong className="text-charcoal font-semibold" data-id="element-339">
                RESET 48: Casa Caminable en 2 Días
              </strong>{' '}
              <span className="text-warm-gray" data-id="element-340">(sin motivación)</span>.
            </p>
            <p data-id="element-341">No es "limpieza profunda".</p>
            <p data-id="element-342">No es "organización estética".</p>
            <p className="font-medium text-charcoal" data-id="element-343">
              Es un reset funcional para que puedas volver a vivir en tu casa.
            </p>
          </div>
        </AnimatedSection>

        {/* T-B-R Method */}
        <AnimatedSection delay={0.15} data-id="element-344">
          <div className="mb-4" data-id="element-345">
            <h3 className="font-serif text-2xl md:text-3xl text-charcoal mb-1" data-id="element-346">
              El Método T‑B‑R
            </h3>
            <p className="text-warm-gray text-base italic mb-5" data-id="element-347">
              Por fin, algo que no te pide pensar.
            </p>
          </div>
        </AnimatedSection>

        <AnimatedSection delay={0.2} data-id="element-348">
          <div className="bg-white/70 rounded-2xl border border-cream-dark p-5 md:p-6 mb-4" data-id="element-349">
            <div className="flex items-start gap-4" data-id="element-350">
              <div className="w-12 h-12 rounded-xl bg-teal/10 flex items-center justify-center flex-shrink-0" data-id="element-351">
                <TrashIcon className="w-6 h-6 text-teal" data-id="element-352" />
              </div>
              <div data-id="element-353">
                <div className="flex items-baseline gap-2 mb-2" data-id="element-354">
                  <span className="font-serif text-2xl text-teal" data-id="element-355">T</span>
                  <span className="text-charcoal font-semibold text-lg" data-id="element-356">
                    — TRASH
                  </span>
                </div>
                <p className="text-charcoal font-medium mb-1" data-id="element-357">
                  Basura primero.
                </p>
                <p className="text-warm-gray text-base leading-relaxed" data-id="element-358">
                  Porque reduce volumen, limpia el aire y te devuelve espacio
                  rápido.
                </p>
              </div>
            </div>
          </div>
        </AnimatedSection>

        <AnimatedSection delay={0.25} data-id="element-359">
          <div className="bg-white/70 rounded-2xl border border-cream-dark p-5 md:p-6 mb-4" data-id="element-360">
            <div className="flex items-start gap-4" data-id="element-361">
              <div className="w-12 h-12 rounded-xl bg-sand/20 flex items-center justify-center flex-shrink-0" data-id="element-362">
                <ShoppingBagIcon className="w-6 h-6 text-sand" data-id="element-363" />
              </div>
              <div data-id="element-364">
                <div className="flex items-baseline gap-2 mb-2" data-id="element-365">
                  <span className="font-serif text-2xl text-sand" data-id="element-366">B</span>
                  <span className="text-charcoal font-semibold text-lg" data-id="element-367">
                    — BASKETS
                  </span>
                </div>
                <p className="text-charcoal font-medium mb-1" data-id="element-368">
                  Canastas por destino, sin ordenar.
                </p>
                <p className="text-warm-gray text-base leading-relaxed" data-id="element-369">
                  Porque separa el caos sin meterte en decisiones infinitas.
                </p>
              </div>
            </div>
          </div>
        </AnimatedSection>

        <AnimatedSection delay={0.3} data-id="element-370">
          <div className="bg-white/70 rounded-2xl border border-cream-dark p-5 md:p-6 mb-6" data-id="element-371">
            <div className="flex items-start gap-4" data-id="element-372">
              <div className="w-12 h-12 rounded-xl bg-teal/10 flex items-center justify-center flex-shrink-0" data-id="element-373">
                <RotateCcwIcon className="w-6 h-6 text-teal" data-id="element-374" />
              </div>
              <div data-id="element-375">
                <div className="flex items-baseline gap-2 mb-2" data-id="element-376">
                  <span className="font-serif text-2xl text-teal" data-id="element-377">R</span>
                  <span className="text-charcoal font-semibold text-lg" data-id="element-378">
                    — RESET
                  </span>
                </div>
                <p className="text-charcoal font-medium mb-1" data-id="element-379">
                  Superficies + piso funcional.
                </p>
                <p className="text-warm-gray text-base leading-relaxed" data-id="element-380">
                  Porque una casa caminable se sostiene mejor que una casa
                  "perfecta".
                </p>
              </div>
            </div>
          </div>
        </AnimatedSection>

        <AnimatedSection delay={0.35} data-id="element-381">
          <div className="text-center bg-teal-light/40 rounded-2xl p-5 md:p-6" data-id="element-382">
            <p className="text-charcoal text-base md:text-lg leading-relaxed mb-1" data-id="element-383">
              Es literalmente esto:
            </p>
            <p className="font-serif text-xl md:text-2xl text-teal" data-id="element-384">
              Basura → Canastas → Reset.
            </p>
            <p className="text-warm-gray text-base mt-3 italic" data-id="element-385">
              Lo haces aunque estés cansada.
            </p>
          </div>
        </AnimatedSection>
      </div>
    </section>;
}